import { gql } from '@apollo/client';

// Grupos de personas que comparten las marcas «Importante».
export const FETCH_USER_GROUPS = gql`
  query FetchUserGroups {
    userGroups {
      id
      name
      createdAt
      updatedAt
      members {
        id
        name
        surName
        email
        rolActive
        isActive
      }
    }
  }
`;
